import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box, Tooltip } from '@components/common';
import ScheduleBoard from '@components/ScheduleBoard';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import { AppSelectors } from '@redux/AppRedux';
import DragHandle from '@components/draggable/DraggableIcon';
import SvgIcon from '@components/SvgIcon';
import { DRAG_ITEM_TYPES } from '@redux/DragRedux';
import useDetectSize from '@hooks/useDetectSize';
import { colors } from '@styles/theme';

const SpecialItemIcon = styled(SvgIcon)``;

function AddonBoardView(props) {
  const {
    selectedItems,
    numOfRows,
    moveItem,
    serviceTypeData,
    rescheduleInfo,
    blockedCols
  } = props;

  const { week: rescheduleWeek, day: rescheduleDay } = rescheduleInfo || {
    week: 2,
    day: 5
  };

  const isMobile = useDetectSize();
  const specialItems = selectedItems.reduce((acc, item) => {
    let { serviceType, addons, rescheduleItem, ...otherItems } = item;

    let { row, col, ...restItem } = otherItems;

    if (rescheduleItem && !rescheduleItem.skip) {
      const { row: newRow, col: newCol } = rescheduleItem;
      row = newRow;
      col = newCol;
    }

    if (!acc[`row_${row}`]) {
      acc[`row_${row}`] = {};
    }
    acc[`row_${row}`][`col_${col}`] = {
      row,
      col,
      serviceType,
      addons,
      rescheduleItem,
      ...restItem
    };
    return acc;
  }, {});

  const errorExtractor = (row, col) => {
    return +row === +rescheduleWeek - 1 && +col === +rescheduleDay - 1;
  };
  const filledExtractor = () => {
    return false;
  };
  const disabledExtractor = row => {
    return row !== +rescheduleWeek - 1;
  };

  const handleOnDrop = (item, row, col) => {
    if (errorExtractor(row, col)) {
      return;
    }

    moveItem(
      { row: +rescheduleWeek - 1, col: +rescheduleDay - 1 },
      {
        row,
        col
      }
    );
  };

  const renderItem = (specialItem, disabled) => {
    const { serviceType, row } = specialItem;

    const serviceTypeDetail = serviceTypeData[serviceType];
    const { fullTitle } = serviceTypeDetail;
    const iconFill = disabled ? 'darkGray' : undefined;

    const iconProps = isMobile
      ? { width: 24, height: 24 }
      : { width: 16, height: 16 };

    const isRescheduleItem = +row === +rescheduleWeek - 1;

    return (
      <Box display="flex" flexDirection="column" position="relative">
        {!isRescheduleItem ? (
          <Tooltip
            animation="scale"
            delay={[300, 0]}
            duration={300}
            content={fullTitle}
            theme="light-border"
            placement="bottom"
          >
            <span>
              <SpecialItemIcon
                name={serviceType}
                fill={iconFill ? colors[iconFill] : undefined}
                disabled={disabled}
                {...iconProps}
              />
            </span>
          </Tooltip>
        ) : (
          <DragHandle
            icon={serviceType}
            dragType={DRAG_ITEM_TYPES.REMOVABLE}
            onDrop={(row, col) => handleOnDrop(specialItem, row, col)}
          />
        )}
      </Box>
    );
  };
  return (
    <Box display="flex" flexDirection="row">
      <ScheduleBoard
        reservedCols={blockedCols}
        numOfRows={numOfRows}
        errorCell={{ week: rescheduleWeek, day: rescheduleDay }}
        specialItems={specialItems}
        renderSpecialItem={renderItem}
        disabledExtractor={disabledExtractor}
        filledExtractor={filledExtractor}
        errorExtractor={errorExtractor}
      />
    </Box>
  );
}

AddonBoardView.propTypes = {
  selectedItems: PropTypes.array,
  numOfRows: PropTypes.number,
  moveItem: PropTypes.func,
  serviceTypeData: PropTypes.object,
  rescheduleInfo: PropTypes.object,
  blockedCols: PropTypes.array
};

const mapStatesToProps = state => ({
  selectedItems: ScheduleSelectors.selectScheduledItems(state),
  numOfRows: ScheduleSelectors.selectNumOfRows(state),
  serviceTypeData: AppSelectors.selectServiceTypeData(state),
  rescheduleInfo: ScheduleSelectors.selectRescheduleInfo(state),
  blockedCols: ScheduleSelectors.selectBlockedDays(state)
});

const mapDispatchToProps = dispatch => ({
  moveItem: (item, newItem) =>
    dispatch(ScheduleActions.attachRescheduleInfoToItem(item, newItem))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AddonBoardView);
